import React from 'react';
import { Flex, HStack, Text } from '@chakra-ui/react';
import ExportProfileAction, { getVisibleActionError } from '../ExportProfileAction';
import SharingLinkControls from '../SharingLinkControls';
import FineTuneProfileAction from './FineTuneProfileAction';
import EditControls from './EditControls';

const AdminToolbar = ({
  isEditing,
  isSaving,
  person,
  creatingProfile,
  handleFineTuneProfile,
  exportLinks,
  handleExportProfile,
  exporting,
  actionErrors,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onTextAssist,
  isTextAssisting,
  canRequestTextAssist
}) => {
  // In edit mode admins see the same edit bar as everyone else.
  if (isEditing) {
    return (
      <EditControls
        isEditing
        isSaving={isSaving}
        onCancelEdit={onCancelEdit}
        onSaveEdit={onSaveEdit}
        onTextAssist={onTextAssist}
        isTextAssisting={isTextAssisting}
        canRequestTextAssist={canRequestTextAssist}
      />
    );
  }

  const personId = person?.personid;
  // Sharing and export apply once the person has a generated profile, as before.
  const hasProfile = Boolean(personId) && person?.description != null;
  const actionError = getVisibleActionError(actionErrors, personId);

  return (
    <Flex direction="column" gap={2} mb={4}>
      <Flex alignItems="center" justifyContent="space-between" gap={4} flexWrap="wrap">
        <div>
          {hasProfile && <SharingLinkControls sharingToken={person?.sharing_link?.token ?? null} panel size="md" />}
        </div>
        <HStack spacing={3} flexWrap="wrap" justifyContent="flex-end">
          {hasProfile && (
            <ExportProfileAction
              personId={personId}
              exportLinks={exportLinks}
              exporting={exporting}
              onExportProfile={handleExportProfile}
              size="md"
            />
          )}
          <FineTuneProfileAction
            person={person}
            creatingProfile={creatingProfile}
            onRefreshProfile={handleFineTuneProfile}
          />
          <EditControls isEditing={false} isSaving={isSaving} onStartEdit={onStartEdit} mb={0} />
        </HStack>
      </Flex>
      {actionError && (
        <Text fontSize="sm" color="red.500" textAlign="right">
          {actionError}
        </Text>
      )}
    </Flex>
  );
};

export default AdminToolbar;
